<template>
  <div class="row  signup">
    <div class="col-md-6 mx-auto">
      <div class="tile">
        <h3 class="tile-title">Dosya Paylaşım Sitesine Üye Ol!</h3>
        <div>
          <div
            class="card-body tex-center d-flex align-items-center flex-column"
          >
            <img
              style="margin-left: auto; margin-right: auto;margin-bottom:12px"
              id="profile-container"
              :src="
                product.selectedImage == null
                  ? this.result.imgSrc + this.result.img_url
                  : product.selectedImage
              "
            />
            <input
              ref="file"
              type="file"
              style="display: none;"
              @change="onChange($event)"
              class="form-control"
            />
            <button
              class="btn btn-outline-secondary "
              type="button"
              @click="$refs.file.click()"
            >
              Resim Seç
            </button>
          </div>
        </div>

        <div class="tile-body">
          <form>
            <div class="form-group">
              <label class="control-label">Adı:</label>
              <input
                v-model="result.name"
                class="form-control"
                type="text"
                placeholder="Adınızı Giriniz"
                required
              />
            </div>
            <div class="form-group">
              <label class="control-label">Soyadı:</label>
              <input
                v-model="result.surname"
                class="form-control"
                type="text"
                placeholder="Soyadınızı Giriniz"
                required
              />
            </div>
            <div class="form-group">
              <label class="control-label">Email:</label>
              <input
                v-model="result.email"
                class="form-control"
                type="email"
                placeholder="Email Adresinizi Giriniz"
                required
              />
            </div>
            <div id="app">
              <label class="control-label">Bölüm:</label>
              <select class="form-control" @change="changeJobTitle($event)">
                <option value="" selected disabled>Bölümünüzü Seçiniz</option>
                <option
                  v-for="jobTitle in jobTitles"
                  :value="jobTitle.id"
                  :key="jobTitle.id"
                  >{{ jobTitle.sectionName }}</option
                >
              </select>
            </div>
            <div class="row">
              <div class="col-md-12 offset-md-12">
                <form
                  action="page2.php"
                  id="myForm1"
                  class="needs-validation"
                  novalidate
                >
                  <div class="form-group">
                    Parola:<input
                      v-model="result.password"
                      type="password"
                      id="pwdId"
                      class="form-control"
                      pattern="^[a-z]{2,4}$"
                      required
                      placeholder="Şifrenizi Giriniz"
                    />
                    <p style="color: red">{{ warnPass }}</p>
                    <div class="valid-feedback">Şifreler Uyuşuyor</div>
                    <div class="invalid-feedback">
                      a to z only (2 to 4 long)
                    </div>
                  </div>
                  <div class="form-group">
                    Parola:<input
                      v-model="result.passValid"
                      type="password"
                      id="cPwdId"
                      class="form-control"
                      pattern="^[a-z]{2,4}$"
                      required
                      placeholder="Şifrenizi Tekrar Giriniz"
                    />
                    <p style="color: red">{{ warnPassValid }}</p>
                    <div id="cPwdValid" class="valid-feedback">
                      Şifreler Uyuşuyor
                    </div>
                    <div id="cPwdInvalid" class="invalid-feedback">
                      a to z only (2 to 4 long)
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </form>
        </div>

        <div class="tile-footer">
          <button @click="uploadFile()" class="btn btn-primary" type="button">
            <i class="fa fa-fw fa-lg fa-check-circle"></i>Kaydol
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      result: {
        img_url : "man-in-suit-and-tie.svg",
        name: "",
        surname: "",
        email: "",
        password: "",
        passValid: "",
        imgSrc: store.state.img_base_url,
      },
      warnPass: "",
      warnPassValid: "",
      file: "",
      fileWarn: "",
      product: {
        selectedImage: null,
      },
      jobTitles: [],
      selectedJobTitle: null,
      sectionId : null
    };
  },
  methods: {
    onChange(e) {
      const file = e.target.files[0];
      this.product.selectedImage = URL.createObjectURL(file);
    },
    changeJobTitle(event) {
      console.log(event.target.value)
      this.selectedJobTitle = event.target.options[event.target.options.selectedIndex].text;
      this.sectionId = event.target.value;
    },

    reload: function() {
      location.reload();
    },

    uploadFile: function() {
      this.file = this.$refs.file.files[0];
      if (!this.$refs.file.files[0]) {
        return this.sendData();
      }
      var result = this.result;
      var sendData = this.sendData;
      if (this.file.size > 2500000) {
        this.fileWarn =
          "Yükleyeceğiniz Dosya Boyutu 2.5 Mb'yi Aşamaz!  " +
          " Dosya Boyutunuz : " +
          this.file.size / 1000000 +
          "Mb";
        //console.log("dosya boyutu büyük");
        return;
      }
      let formData = new FormData();
      formData.append("file", this.file);
      var query = store.state.img_upload_sigup;
      axios
        .post(query, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function(response) {
          //console.log(response);
          if (response.data.result) {
            //console.log("işlem başarılı");
            result.img_url = response.data.data;
            sendData();
          } else {
            //console.log("işlem başarısız");
          }
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    sendData: function() {
      var url = store.state.base_url + "User/createUser.php?key=123";

      var datas = {
        name: this.result.name,
        surname: this.result.surname,
        email: this.result.email,
        password: this.result.password,
        img_url: this.result.img_url,
        sectionId: this.sectionId,
      };

      if (this.result.passValid != this.result.password) {
        this.warnPassValid = "parolalar eşleşmiyor";
        return false;
      }
      if (this.result.passValid == "" || this.result.password == "") {
        this.warnPass = "lütfen parolayı boş bırakmayınız";
        return false;
      }

      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          console.log(response.data);
          if (response.data.result == true) {
            this.$swal({
              text: "Kayıt İşleminiz Başarıyla Gerçekleştirildi!",
              icon: "success",
              closeOnClickOutside: false,
            });
            this.$router.push({name : 'login'});
          }else if(response.data == 2002){
            alert("Sistemde Email Adresinizle İlişkili Bir Hesap Bulunmakta Giriş Yapmayı Deneyiniz.");
            this.$router.push({name : 'login'});
          }else{
            alert("Hata! Parametreleri Kontrol Ettikten Sonra Tekrar Deneyiniz.")
          }
        })
        .catch((error) => {
        });
    },

  },
  mounted() {
    var url = store.state.base_url + "Sections/getAllSections.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.jobTitles=response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SignUp.vue